import { IS_LOCAL } from '@/helpers';

const I18N = {
  ko: {
    dailyMissionDetail: {
      dateFormat: 'yy.LL.dd',
    },
  },
  en: {
    dailyMissionDetail: {
      dateFormat: 'LLL dd, yyyy',
    },
  },
};

const BarbequeStore = {
  namespaced: true,
  state() {
    return {
      /** 데일리 미션 상태 */
      dailyMissionStatus: {
        attendance: 1,
        invite: 0,
        subs: 0,
        rentalIncome: 0,
        swap: 0,
      },
      /** 데일리 미션 상세 */
      dailyMissionDetail: [],
      /** 획득 재료 내역 */
      ingredientStatus: {
        unused: 0,
        total: 0,
      },
      /** 나의 완성 바비큐 상태 */
      myCompletedBarbequeStatus: {
        usrCompleteBarbeques: 0,
        receivedBarbequeRewards: [],
      },
    };
  },
  getters: {
    getDailyMissionDetailSum: (state) => state.dailyMissionDetail.reduce((acc, item) => acc + item.value, 0),
  },
  mutations: {
    setDailyMissionStatus(state, status) {
      state.dailyMissionStatus = status;
    },
    setDailyMissionDetail(state, detail) {
      state.dailyMissionDetail = detail;
    },
    setIngredientStatus(state, status) {
      state.ingredientStatus = status;
    },
    setMyCompletedBarbequeStatus(state, status) {
      state.myCompletedBarbequeStatus = status;
    },
  },
  actions: {
    async fetch(_, { method, url, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;
      const response = await this._vm.$axios[method](`${process.env.VUE_APP_TEST_SERVER}${url}`, data);
      return response;
    },
    /**
     * 데일리 미션 상태 조회
     * @returns {Promise<{
     *   invite: number;
     *   subs: number;
     *   rentalIncome: number;
     *   swap: number;
     * }>}
     */
    async getDailyMissionStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            invite: 4,
            subs: 2,
            rentalIncome: 1,
            swap: 1,
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/barbeque/mission',
      });
      return response;
    },
    /**
     * 데일리 미션 상태 조회
     */
    async fetchDailyMissionStatus({ dispatch, commit }) {
      const { data: dailyMissionStatus } = await dispatch('getDailyMissionStatus');

      commit('setDailyMissionStatus', dailyMissionStatus);

      return;
    },
    /**
     * 데일리 미션 상세 조회
     * @returns {Promise<{
     *   date: string;
     *   content: string;
     *   value: number;
     * }[]>}
     */
    async getDailyMissionDetail({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: [
            {
              date: '2023-01-01T00:00:00',
              content: '출석 체크 완료',
              value: 1,
            },
            {
              date: '2023-01-02T00:00:00',
              content: '출석 체크 완료',
              value: 4,
            },
          ],
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/barbeque/mission/detail',
      });
      return response;
    },
    /**
     * 데일리 미션 상세 조회
     */
    async fetchDailyMissionDetail({ dispatch, commit, rootState }) {
      const { data: dailyMissionDetail } = await dispatch('getDailyMissionDetail');
      const { lang } = rootState;

      const format = I18N[lang].dailyMissionDetail.dateFormat;
      const formattedDailyMissionDetail = dailyMissionDetail.map((item) => ({
        ...item,
        date: this._vm.$tl(item.date, lang).toFormat(format),
      }));

      commit('setDailyMissionDetail', formattedDailyMissionDetail);
      return;
    },
    /**
     * @description 획득 재료 내역 조회
     */
    async getIngredientStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            unused: 5,
            total: 9,
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/barbeque/opportunity',
      });
      return response;
    },
    /** 획득 재료 내역 조회 */
    async fetchIngredientStatus({ dispatch, commit }) {
      const { data: ingredientStatus } = await dispatch('getIngredientStatus');
      console.log(ingredientStatus);
      commit('setIngredientStatus', ingredientStatus);

      return;
    },
    /**
     * @description 나의 완성 바비큐 상태 조회
     */
    async getMyCompletedBarbequeStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            usrCompleteBarbeques: 5,
            receivedBarbequeRewards: [1],
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/barbeque/reward/complete',
      });
      return response;
    },
    /** 나의 완성 바비큐 상태 조회 */
    async fetchMyCompletedBarbequeStatus({ dispatch, commit }) {
      const { data: myCompletedBarbequeStatus } = await dispatch('getMyCompletedBarbequeStatus');
      console.log(myCompletedBarbequeStatus);
      commit('setMyCompletedBarbequeStatus', myCompletedBarbequeStatus);

      return;
    },
    /**
     * @description 바비큐 완성 보상 받기
     * @returns {Promise<number>}
     * @example 1 // 0.5, 1, 2, 2.5, 5
     */
    async postBarbequeReward({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: 1,
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/barbeque/draw',
      });
      return response;
    },
    /** 바비큐 완성 보상 받기 */
    async submitBarbequeReward({ dispatch }) {
      try {
        const { data } = await dispatch('postBarbequeReward');
        return data;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchIngredientStatus');
        dispatch('fetchMyCompletedBarbequeStatus');
      }
    },
    /** 완성 바비큐 보상 받기 */
    async postCompletedBarbequeReward({ dispatch }, index) {
      if (IS_LOCAL) {
        return {
          omc: 1,
          lCoupon: 2,
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/barbeque/reward/complete',
        params: {
          barbeque: index,
        },
      });
      return response;
    },
    /** 완성 바비큐 보상 받기 */
    async submitCompletedBarbequeReward({ dispatch }, index) {
      try {
        const { data } = await dispatch('postCompletedBarbequeReward', index);

        return data;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchMyCompletedBarbequeStatus');
      }
    },
  },
};

export default BarbequeStore;
